import { useEffect, useState } from 'react'
import {
  IntersectionObserverHookRefCallback,
  useIntersectionObserver,
} from 'react-intersection-observer-hook'
import { StringParam, useQueryParams } from 'use-query-params'

type UseChartVisible = () => {
  isVisible: boolean
  chartRef: IntersectionObserverHookRefCallback
}

const useChartVisible: UseChartVisible = () => {
  const [query] = useQueryParams({
    intersection: StringParam,
  })
  const [chartRef, { entry }] = useIntersectionObserver()
  const [isVisible, setIsVisible] = useState(
    entry?.isIntersecting ?? query.intersection === 'false',
  )

  useEffect(() => {
    if (isVisible) {
      return
    }
    if (query.intersection !== 'false' && !entry?.isIntersecting) {
      return
    }

    setIsVisible(true)
  }, [entry?.isIntersecting, query.intersection, isVisible])

  return { chartRef, isVisible }
}

export default useChartVisible
